import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import ahaApi from "../../../app/services/aha-api";
const initialState = {
  value: [],
  loading: false,
};

export const getProfile = createAsyncThunk(
  "profile/getProfile",
  async (data, { rejectWithValue }) => {
    const response = await ahaApi.Account.profile()
      .then((res) => {
        return res;
      })
      .catch((err) => {
        return rejectWithValue(err.response.data);
      });

    return response;
  }
);

export const profileSlice = createSlice({
  name: "profile",
  initialState,

  extraReducers: (builder) => {
    builder
      .addCase(getProfile.pending, (state) => {
        state.loading = true;
      })
      .addCase(getProfile.fulfilled, (state, action) => {
        state.loading = false;
        state.value = action.payload;
      })
      .addCase(getProfile.rejected, (state, err) => {
        state.loading = false;
        state.value = err.payload;
      });
  },
});

export const profileList = (state) => state.profile ? state.profile.value || [] : [];
export const profileLoader = (state) => state.profile ? state.profile.loading || false : false;

export default profileSlice.reducer;
